import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { Contact } from '@iot-platform/models/common';
import { TranslatePipe } from '@ngx-translate/core';
import { DetailContactCardComponent } from '../../detail-popup-cards/detail-contact-card/detail-contact-card.component';
import { DetailPopupSectionHeaderComponent } from '../../detail-popup/detail-popup-section-header/detail-popup-section-header.component';

@Component({
  imports: [FlexLayoutModule, TranslatePipe, DetailPopupSectionHeaderComponent, DetailContactCardComponent],
  selector: 'iot-platform-ui-site-detail-contacts',
  templateUrl: './site-detail-contacts.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./site-detail-contacts.component.scss']
})
export class SiteDetailContactsComponent {
  contacts = input<Contact[]>([]);
  canReadContacts = input<boolean>(false);
}
